import { Component } from "@angular/core";
import { MatCard, MatCardContent } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { RouterLinkActive, RouterLink } from "@angular/router";

@Component({
    selector: "app-unauthorized",
    templateUrl: "./unauthorized.component.html",
    styleUrls: ["./unauthorized.component.scss"],
    imports: [MatCard, MatCardContent, MatIcon, RouterLinkActive, RouterLink],
})
export class UnauthorizedComponent {
    constructor() {}
}
